import { PrimaryTextColor,primaryRedColor, primaryGrayBg, boldFont, getRelativeFontSize, mediumFont, heading, primaryBlueColor, primaryLightGray, primaryWhiteColor, regularFont, subHeading, PrimaryLightTextColor, borderColor, primarygreenColor } from "../../../../utils/styles";

const ShowAllStyles = {
  headerWrapper: {
    padding: "0 20px",
  },
  pageHeading: {
    ...heading,
  },
  sideBoxWrapper:{
    padding: "20px",
    height: "90vh",
    width: "85%",
    backgroundColor: "rgb(255 255 255)",
    overflow : "auto",
    '&::-webkit-scrollbar': {
    display: "none",
    width:"0px"
}
  },
  closeButton: {
    position: "fixed",
    top: "70px",
    right: "12px",
    zIndex: "9999",
  },
  closeIcon:{
    fontSize: "1rem",
  },
  autocomplateStyle: {
    width: "100%",
    maxHeight:'38px',
    background: "#e7e7e7",
    "& .MuiSvgIcon-root ":{
      display:"none"
    },
    "& .MuiInputBase-input": {
      color: PrimaryTextColor,
      ...regularFont,
      fontSize: getRelativeFontSize(0),

      "&::placeholder": {
        ...regularFont,
        fontSize: getRelativeFontSize(0),
        color: PrimaryLightTextColor,
      },
    },
    "&  .MuiOutlinedInput-root": {
      padding: "0.5px 9px",
    },
    "&  .MuiTextField-root": {
      maxHeight:'38px',
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "4px",
      display:'flex',
      flexWrap: "initial",
      overflow:'hidden',
      "&.Mui-focused fieldset": {
        borderColor: "#E7E7EA",
      },
      "&:hover fieldset": {
        borderColor: "#E7E7EA",
      },
    },
    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
      borderColor: "#E7E7EA",
    },
    "& .MuiChip-label":{
      fontSize:"11px",
      padding:"0 8px",
    },
    "& .MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium":{
      fontSize:"16px",
    },
  },


  autocompleteStyle: {
    width: "200px",
    maxHeight:'40px',
    // background: "#e7e7e7",

    "& .MuiSvgIcon-root ":{
      display:"none"
    },
    "& .MuiInputBase-input": {
      color: PrimaryTextColor,
      ...regularFont,
      fontSize: getRelativeFontSize(0),

      "&::placeholder": {
        ...regularFont,
        fontSize: getRelativeFontSize(0),
        color: PrimaryLightTextColor,
      },
    },
    "&  .MuiOutlinedInput-root": {
      padding: "0.5px 9px",
    },
    "&  .MuiTextField-root": {
      maxHeight:'38px',
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "4px",
      display:'flex',
      flexWrap: "initial",
      overflow:'hidden',
      height:"38px",
      "&.Mui-focused fieldset": {
        borderColor: "#E7E7EA",
      },
      "&:hover fieldset": {
        borderColor: "#E7E7EA",
      },
    },
    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
      borderColor: "#E7E7EA",
    },
    "& .MuiAutocomplete-tag":{
      height:"auto",
    },
    "& .MuiChip-label":{
      fontSize:"11px",
      padding:"0 8px",
      
    },
    "& .MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium":{
      fontSize:"16px",
    },
   
  },
  autoInputBlank: {
    "& .MuiFormHelperText-root.Mui-error": {
      color: "#d32f2f",
      fontSize: getRelativeFontSize(),
      ...regularFont,
      marginLeft: "5px",
      marginBottom: "5px",
    },
    "& .MuiAutocomplete-input": {
      fontSize: getRelativeFontSize(),
      padding:"4px 5px",
    },
  },

  autoInputFill: {
    "& .MuiFormHelperText-root.Mui-error": {
      color: "#d32f2f",
      fontSize: getRelativeFontSize(-3),
      ...regularFont,
      marginLeft: "5px",
      marginBottom: "5px",
    },
  },
  content: {
    padding: "0 70px",
  },
  checkBoxWarapper: {
    diplay: "flex",
    marginTop: "10px",
  },
  pageSubHeading: {
    ...subHeading,
  },
  statusHeading: {
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(),
    ...mediumFont,
  },
  showAllWrapper: {
    "& .MuiDataGrid-columnHeaderTitle":{
      ...boldFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(0),
    textTransform: "capitalize",
    },
    "& .MuiTablePagination-root":{
      ...regularFont,
      color: PrimaryTextColor,
      fontSize: getRelativeFontSize(0),

      "& .MuiTablePagination-selectLabel":{
        fontSize: getRelativeFontSize(0),
      },
      "& .MuiTablePagination-displayedRows":{
        fontSize: getRelativeFontSize(0),
      },
      
    },
    "& .MuiDataGrid-toolbarContainer":{
      ...regularFont,
      fontSize: getRelativeFontSize(0),

      "& .MuiInputBase-root":{
        ...regularFont,
        fontSize: getRelativeFontSize(0),

        "& .MuiSvgIcon-root":{
          fontSize:"1.2rem",
        },
      },
      "& .MuiButtonBase-root":{
        ...regularFont,
        fontSize: getRelativeFontSize(0),

        "& .MuiButton-startIcon":{
          marginRight:"0.313rem",
          marginLeft:"0",

          "& .MuiSvgIcon-root":{
            fontSize:"1.2rem",
          },
        },
      },
    },
    "& .MuiStack-root>:not(style):not(style)":{
      marginTop:"0",
    },
    "& .MuiSelect-select":{
      padding:"5px 10px",
    },
  },
  showAllWrapper1: {
    "& .MuiDataGrid-columnHeaderTitle":{
      ...boldFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(0),
    textTransform: "capitalize",
    },
    "& .MuiTablePagination-root":{
      ...regularFont,
      color: PrimaryTextColor,
      fontSize: getRelativeFontSize(0),

      "& .MuiTablePagination-selectLabel":{
        fontSize: getRelativeFontSize(0),
      },
      "& .MuiTablePagination-displayedRows":{
        fontSize: getRelativeFontSize(0),
      },
      
    },
    "& .MuiDataGrid-toolbarContainer":{
      ...regularFont,
      fontSize: getRelativeFontSize(0),

      "& .MuiInputBase-root":{
        ...regularFont,
        fontSize: getRelativeFontSize(0),

        "& .MuiSvgIcon-root":{
          fontSize:"1.2rem",
        },
      },
      "& .MuiButtonBase-root":{
        ...regularFont,
        fontSize: getRelativeFontSize(0),

        "& .MuiButton-startIcon":{
          marginRight:"0.313rem",
          marginLeft:"0",

          "& .MuiSvgIcon-root":{
            fontSize:"1.2rem",
          },
        },
      },
    },
    "& .MuiStack-root>:not(style):not(style)":{
      marginTop:"0",
    },
    "& .MuiSelect-select":{
      padding:"5px 10px",
    },
  },

  datePickerBox:{
    margin:"0 5%",
    width:"40%",

    "& .MuiFormLabel-root":{
      fontSize: getRelativeFontSize(0),
      top:"-3px",
    },
    "& .MuiInputBase-input": {
      color: PrimaryTextColor,
      ...regularFont,
      fontSize: getRelativeFontSize(0),
      padding:"12px 10px",
    },
  },
  buttonArea: {
    display:"flex",
    alignItems:"center",
    justifyContent:"end",
    width:"25%",

    "& button":{
      width:"auto",
      minWidth:"150px",
    },
  },
  reminder:{
    ...boldFont,
    fontSize: getRelativeFontSize(-2),
    color:primaryRedColor,
    background:primaryWhiteColor,
    border:"1px solid",
    borderColor:primaryRedColor,
    borderRadius:"4px",
    height: "32px",
    width: "70px",
    padding:"6px",
  },
  stageButton:{
    "& .stageBtn":{
      height: "32px",
      width: "70px",
      ...boldFont,
      fontSize: getRelativeFontSize(-2),
      textTransform:"capitalize",
      background:"#cd9118",
      border:"1px solid #cd9118",
      borderRadius:"4px",
      color: primaryWhiteColor,
      cursor:"pointer",

      "&:hover": {
        background:primaryWhiteColor,
        color:"#cd9118",
      },
    },
  },
  assignButton:{
    "& .assignBtn":{
      height: "32px",
      width: "70px",
      ...boldFont,
      fontSize: getRelativeFontSize(-2),
      textTransform:"capitalize",
      background:"#4ca2be",
      border:"1px solid #4ca2be",
      borderRadius:"4px",
      color: primaryWhiteColor,
      cursor:"pointer",

      "&:hover": {
        background:primaryWhiteColor,
        color:"#4ca2be",
      },
    },
  },
  buttonWrapper: {
    display: "flex",
    justifyContent: "flex-start",
    gap: "5px",
    flexDirection: "column",

    "& button": {
      color: primaryBlueColor,
      height: "10px",
      fontSize: getRelativeFontSize(-2),
    },
  },

  buttonWrapperDialog: {
    width: "350px",
    display: "flex",
    justifyContent: "flex-start",
    gap: "10px",
    "& button": {
      color: primaryBlueColor,
      fontSize: getRelativeFontSize(-2),
      "&:nth-child(2)": {
        color: "#ffffff",
      },
    },
  },
 centerText:{
  display: "flex",
 alignItems:"center",
 gap:"5px",
 fontSize:"12px"
 },
  subHeaderName: {
    ...regularFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(-2),
    // textTransform: "capitalize",
  },
 
  headerName: {
    ...boldFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(-2),
    textTransform: "capitalize",
  },
  dipt: {
    color: "#6D6E82",
    ...boldFont,
  },



  emp_type_btn: {
    background: "#18CB8A",
    width: "60px",
    height: "18px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: getRelativeFontSize(-4),
    textTransform: "capitalize",
    ...regularFont,
    borderRadius: "4px",
    color: "#ffffff",
  },

  activeBtn: {
    "& button": {
      height: "23px",
      width: "54px",
      fontSize: getRelativeFontSize(-3),
      ...mediumFont,
    },
  },

  deActive: {
    "& button": {
      height: "23px",
      width: "54px",
      fontSize: getRelativeFontSize(-3),
      ...mediumFont,
      background: "red",
      borderColor: "red",
      "&:hover": {
        background: "red",
        borderColor: "red",
      },
    },
  },

  popOverContent: {
    position: "relative",
    top: "20px",
  },

  popOverBtn: {
    position: "absolute",
  },

  Info_btn: {
    height: "18px",
    width: "fit-content",
    padding: "0 10px",
    ...regularFont,
    borderRadius: "4px",
    background: "#F4BE5E",
    fontSize: getRelativeFontSize(-4),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "5px",
    color: "#ffffff",
    textTransform: "capitalize",
  },

  filterButton: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    justifyContent: "center",
    height: "46px",
  },

  filterName: {
    ...mediumFont,
    fontSize: getRelativeFontSize(2),
    color: "#11142D",
    "& img": {
      marginLeft: "10px",
    },
  },

  verticalDotButton: {
    "& button": {
      "&:hover": {
        background: "none",
      },
    },
  },

  innerPopOver: {
    padding: "5px",
    display: "flex",
    width: "100%",
    height: "100%",
    flexDirection: "column",
    justifyContent: "start",
    alignItems: "start",
    "& button": {
      width: "fit-content",
      "&:hover": {
        background: "none",
      },
    },
  },
  customgridStyle:{
    "& .css-yrdy0g-MuiDataGrid-columnHeaderRow":{
      display: "flex",
    justifyContent: "space-between",
    width: "90vW",
    },
  },
  leadName:{
    ...boldFont,
    fontSize: getRelativeFontSize(-2),
    color: PrimaryTextColor,
    lineHeight: "24px",
    textTransform:"capitalize",
  },
  leadName1 : {
    ...mediumFont,
    fontSize: getRelativeFontSize(-2),
    color: primaryLightGray,
    lineHeight: "18px",
  },
  infoSection :{
    display :"flex",
    flexDirection:"column",
    justifyContent :"space-between",
    "& .MuiTypography-root" :{
      ...regularFont,
      fontSize: getRelativeFontSize(-2),
      lineHeight: "18px",
      color: primaryLightGray,
    },
  },
  faceBook : {
    color : "#8B91EF !important",
  },
  callSection : {
    display:"flex",
    justifyContent:"space-between",
    color: primaryBlueColor,

    "& a":{
      ...regularFont,
      display:"flex",
      alignItems:"center",
      justifyContent:"space-between",
      color: primaryBlueColor,
      textDecoration:"none",
      fontSize: getRelativeFontSize(0),
    },

    "& .MuiBox-root" : {
      display: "flex",
      gap: "5px",
      alignItems: "center",
    },
    "& .MuiTypography-root" : {
      fontSize: getRelativeFontSize(0),
    },
    "& .MuiSvgIcon-root" : {
      fontSize: getRelativeFontSize(4),
    },
  },
  editIcon: {
    color: primaryLightGray,
  },
  whatsAppSection : {
    display:"flex",
    justifyContent:"space-between",
    color: "#075e54",
    "& .MuiBox-root" : {
      display: "flex",
      gap: "5px",
      alignItems: "center",
    },
    "& .MuiTypography-root" : {
      fontSize: getRelativeFontSize(0),
    },
    "& .MuiSvgIcon-root" : {
      fontSize: getRelativeFontSize(4),
    },
  },
  formPart:{
    "& .MuiFormLabel-root" : {
      fontSize: getRelativeFontSize(0),
    },
    "& .MuiTypography-root" : {
      fontSize: getRelativeFontSize(-2),
    },
    "& .MuiSvgIcon-root" : {
      fontSize: "1.2rem",
    },
    "& .MuiRadio-root":{
      padding: "4px",
      color: primaryBlueColor,
    },
  },
  inputPart :{
    "& .MuiFormControl-root":{
      display:"flex",
    },
    "& .MuiInputBase-input":{
      fontSize: getRelativeFontSize(-2),
      padding: "5px 10px",
    },
  },
  dateTimeSection:{
    marginTop:"10px",
    "& .MuiFormControl-root":{
      display: "flex",
    },
    "& .MuiInputBase-input" : {
      padding : "10px 5px",
      fontSize : getRelativeFontSize(-3),
    },
  },
  buttonPart: {
    display: "flex",
    justifyContent: "end",
    "& .MuiButtonBase-root":{
      width:"auto",
      height: "auto",
      padding: "0",
      fontSize : getRelativeFontSize(-3),
      minWidth: "55px",
    },
  },
  reminderPart: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  iconsPart: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "5px",
    "& .MuiSvgIcon-root" : {
      fontSize : getRelativeFontSize(0),
    },
  },
  
  // buttonBox:{
  //   marginLeft:"5%",
  //   "& .MuiButtonBase-root":{
  //     height:"41px",
  //   },
  // },
 
  tableGridPart:{
    position: "relative",

    "& .MuiDataGrid-withBorderColor":{
      border: "none",
    },
    "& .MuiDataGrid-main": {
      borderTop: "1px solid #EEEFF2",
    },
    "& .MuiDataGrid-columnHeaders":{
      borderBottom: "1px solid #EEEFF2",
      fontSize:"14px",
      ...boldFont
    },
    "& .MuiDataGrid-rowCount":{
      display:"none",
    },
    "& .MuiSelect-select":{
      fontSize:"14px",
      padding:"4px 10px",
      border:"none",
      outline:"none",
    },
    "& .MuiOutlinedInput-notchedOutline":{
      border:"none",
      outline:"none",
    },
    "& .activeButton":{
      margin:"0 5px",background:"#3D48E5", border:"1px solid #3D48E5",
      color:"#fff",padding:"4px", fontSize:"12px", borderRadius:"4px",
      minWidth:"30px",
      "& .activeButton:hover":{
        backgroundColor:"#3D48E5",
      },
      "& .MuiSvgIcon-root":{
        width:"0.8em",
        height:"0.8em",
      },
    },
    "& .deActiveButton":{
      margin:"0 5px",background:"#e7e7e7", border:"1px solid #e7e7e7",
      color:"#bbb",padding:"4px", fontSize:"12px", borderRadius:"4px",
      minWidth:"30px",
      "& .activeButton:hover":{
        backgroundColor:"#3D48E5",
      },
      "& .MuiSvgIcon-root":{
        width:"0.8em",
        height:"0.8em",
      },
    },
  },

  footer:{
    position: "sticky",
    width: "100%",
    bottom: "0",
    background: "#f7f7f7",
    borderTop: "1px solid #E7E7EA",
    padding: "5px",
    height:"48px",
    display:"flex",
    justifyContent:"end",
  },
  footerRight: {
    display: 'flex',
    justifyContent: 'flex-end',
    fontSize: '11px',
    alignItems: 'center'
  },
  font:{
    "& .MuiPaginationItem-root":{
      fontSize:"13px"
    }
  },

  expired:{
    ...boldFont,
    fontSize: getRelativeFontSize(-2),
    color:primaryRedColor,
    background:primaryWhiteColor,
    border:"1px solid",
    borderColor:primaryRedColor,
    borderRadius:"4px",
    height: "32px",
    width: "70px",
    padding:"6px",
    textAlign: 'center',  
    display: 'flex',     
    justifyContent: 'center',
    alignItems: 'center', 
  },
  reminder1:{
    ...boldFont,
    fontSize: getRelativeFontSize(-2),
    color:primarygreenColor,
    background:primaryWhiteColor,
    border:"1px solid",
    borderColor:primarygreenColor,
    borderRadius:"4px",
    height: "32px",
    width: "70px",
    padding:"6px",
  },

  popUpBox:{
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    margin:"0 auto",
    backgroundColor: primaryWhiteColor,
    border: "1px solid #e0e0e0",
    borderRadius:"4px",
    boxShadow:"",
    padding:"20px",

    "& .heading":{
      ...boldFont,
      fontSize : getRelativeFontSize(4),
      marginBottom:"0.5em",
    },
    "& .teamArea":{
      display:"flex",
      alignItems:"center",
      gap:"1rem",

      "& .teamName":{
        ...boldFont,
        fontSize : getRelativeFontSize(0),
        color:PrimaryTextColor,
      },
      "& .memberNameArea":{
        display:"flex",
        alignItems:"center",
        gap:"0.5rem",

        "& .memberName":{
          ...regularFont,
          fontSize : getRelativeFontSize(0),
          color:PrimaryTextColor,
        },
      },
    },
  },
};

export default ShowAllStyles;
